var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4318(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4318",
    "data-name": "Group 4318",
    transform: "translate(734.277 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M-728.557,19.91a5.2,5.2,0,0,1,5.2-5.193,5.2,5.2,0,0,1,5.062,4.02,10.15,10.15,0,0,1,1.87-.372,7.07,7.07,0,0,0-1.284-2.752l1.358-1.357A8.968,8.968,0,0,1-714.5,18.3a11.71,11.71,0,0,1,1.965.234,10.824,10.824,0,0,0-3.111-6.339A10.848,10.848,0,0,0-723.361,9a10.848,10.848,0,0,0-7.719,3.2,10.835,10.835,0,0,0-3.2,7.714,10.835,10.835,0,0,0,3.2,7.714,10.848,10.848,0,0,0,7.719,3.2c.32,0,.638-.015.953-.042V28.863h0V26.944h0V25.014a5.2,5.2,0,0,1-.953.088A5.2,5.2,0,0,1-728.557,19.91Zm4.242,7.034v1.919a8.97,8.97,0,0,1-4.7-1.952l1.357-1.356A7.07,7.07,0,0,0-724.314,26.944Zm-3.347-12.68-1.357-1.356a8.97,8.97,0,0,1,4.7-1.952v1.919A7.07,7.07,0,0,0-727.661,14.264Zm5.254-1.389V10.956a8.97,8.97,0,0,1,4.7,1.951l-1.357,1.357A7.069,7.069,0,0,0-722.408,12.875Zm-7.959,1.38,1.357,1.356a7.062,7.062,0,0,0-1.39,3.345h-1.92A8.959,8.959,0,0,1-730.367,14.255Zm-1.953,6.607h1.92a7.062,7.062,0,0,0,1.39,3.345l-1.357,1.356A8.959,8.959,0,0,1-732.32,20.862Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M-332.3,322.884a6.992,6.992,0,0,0-2.943-.551,6.992,6.992,0,0,0-2.943.551,2.084,2.084,0,0,0-1.418,1.872V331.1a2.084,2.084,0,0,0,1.418,1.872,6.992,6.992,0,0,0,2.943.551,6.992,6.992,0,0,0,2.943-.551,2.084,2.084,0,0,0,1.418-1.872v-6.341A2.084,2.084,0,0,0-332.3,322.884Zm-.2,8.212c0,.164-.717.808-2.746.808s-2.746-.643-2.746-.808v-1.232a7.3,7.3,0,0,0,2.746.465,7.3,7.3,0,0,0,2.746-.465Zm0-3.19c0,.164-.717.808-2.746.808s-2.746-.643-2.746-.808v-1.192a7.3,7.3,0,0,0,2.746.465,7.3,7.3,0,0,0,2.746-.465Zm-2.746-2.342c-2.029,0-2.746-.643-2.746-.808s.717-.808,2.746-.808,2.746.643,2.746.808S-333.219,325.564-335.248,325.564Z",
    transform: "translate(-379.39 -300.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M-506.52,219.666s-2.423,1.99-2.423,3.236c0,.919.439,1.287,1.108,1.287a1.218,1.218,0,0,0,1.082-.6,11.988,11.988,0,0,1-1.186,1.791h2.839a11.992,11.992,0,0,1-1.186-1.792,1.218,1.218,0,0,0,1.082.6c.669,0,1.108-.369,1.108-1.287C-504.1,221.655-506.52,219.666-506.52,219.666Z",
    transform: "translate(-217.076 -202.868)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4318);
export default __webpack_public_path__ + "static/media/Group 4318.1dfea844471ac6ee74a7b98ba5c82d2e.svg";
export { ForwardRef as ReactComponent };